import { Box, Skeleton } from '@mui/material'
import React from 'react'

const EpgContentSkeleton = () => (
    <Box
        display="flex"
        justifyContent="center"
        pt="20px"
        flexDirection="column">
        <Skeleton
            sx={{
                bgcolor: 'grey.800',
                maxWidth: '100%',
                maxHeight: '60px',
                width: '100vw',
                height: '100vh',
                mb: '20px',
            }}
            animation="wave"
            variant="rectangular"
        />
        <Box display="flex" gap="20px">
            {[...Array(5).keys()].map((index) => (
                <Skeleton
                    key={index}
                    sx={{
                        bgcolor: 'grey.800',
                        maxWidth: '462px',
                        maxHeight: '194px',
                        width: '100vw',
                        height: '100vh',
                        mb: '20px',
                    }}
                    animation="wave"
                    variant="rectangular"
                />
            ))}
        </Box>
        <Box display="flex" mt="16px">
            {[...Array(5).keys()].map((index) => (
                <Box
                    key={index}
                    display="flex"
                    flexDirection="column"
                    mr="20px">
                    {[...Array(8).keys()].map((index) => (
                        <Skeleton
                            sx={{
                                bgcolor: 'grey.800',
                                maxWidth: '368px',
                                maxHeight: '63px',
                                width: '100vw',
                                height: '100vh',
                                mb: '20px',
                            }}
                            key={index}
                            animation="wave"
                            variant="rectangular"
                        />
                    ))}
                </Box>
            ))}
        </Box>
    </Box>
)

export default EpgContentSkeleton
